__turbopack_context__.v({
  "ShareButton": "ShareButton-module__trUujq__ShareButton",
  "text": "ShareButton-module__trUujq__text",
});
